import React, { memo } from 'react';
import DropdownIcon from '../svg/DropdownIcon';

import CheckboxIcon from '../svg/CheckboxIcon';
import CloseIcon from '../svg/CloseIcon';

const Filterbar = ({
	memoizedActiveType,
	memoizedActiveCountry,

	availableTypes,
	availableCountries,

	setTypeParam,
	setCountryParam,

	rootElement,
}) => {

	const handleTypeClick = (value) => {
		setTypeParam(value);
	};

	const handleCountryClick = (value) => {
		setCountryParam(value);
	};

	const clearFilters = () => {
		setTypeParam(null);
		setCountryParam(null);
	 };

	const closeFilterDropdowns = (e) => {
		if (!e.target.classList.contains('.custom-select') && e.target.closest('.custom-select') == null) {
			rootElement.removeEventListener('mousedown', closeFilterDropdowns);
			rootElement.querySelectorAll('.js_react_filter .custom-select__trigger').forEach((element) => {
				element.setAttribute('aria-expanded', 'false');
			});
		}
	};

	const toggleSelectList = (e) => {
		// lines disabled so dropdown closes on selecting option as well
		// if (e.target.tagName.toLowerCase() === 'li' || e.target.tagName.toLowerCase() === 'ul' || e.target.tagName.toLowerCase() === 'input' || e.target.tagName.toLowerCase() === 'label') {
		// 	return;
		// }

		rootElement.removeEventListener('mousedown', closeFilterDropdowns); //commented to keep the dropdown open while selecting
		rootElement.addEventListener('mousedown', closeFilterDropdowns);
		rootElement.querySelectorAll('.js_react_filter .custom-select__trigger').forEach((element) => {
			if (e.currentTarget.contains(element)) {
				element.setAttribute('aria-expanded', element.getAttribute('aria-expanded') == 'true' ? 'false' : 'true');
			} else {
				element.setAttribute('aria-expanded', 'false');
			}
		});
	};

	return (
		<div className="filter">

			{/* type of partners tabs */}
			<div className="filter-tabs">
				<ul className="filter-tabs__list">
					<li
						className={`filter-tabs__item ${ !memoizedActiveType ? 'filter-tabs__item--active' : '' }`}
						role="option"
						onClick={() => handleTypeClick(null)}
						aria-selected={!memoizedActiveType ? 'true' : 'false'}
					>All</li>
					{
						availableTypes.map((type, index) => {
							return (
								<li
									key={index}
									className={`filter-tabs__item ${ type === memoizedActiveType ? 'filter-tabs__item--active' : '' }`}
									role="option"
									onClick={() => handleTypeClick(type)}
								>{Object.values(type)[0]}</li>
							);
						})
					}
				</ul>
			</div>

			{/* country dropdown */}
			<div
				className={`dropdown filter-dropdown input custom-select ${memoizedActiveCountry ? 'has-selected' : ''}`}
				onClick={(e) => toggleSelectList(e)}
			>
				{/* selection button for dropdown */}
				<button
					className="custom-select__trigger filter-dropdown__trigger"
					aria-haspopup="listbox"
					aria-labelledby="type_label"
					aria-expanded="false"
					id="type_button"
				>
					<div className="chosen-label filter-dropdown__label">
						{/* Dynamic title inside button for dropdown */}
						<p className="filter-label filter-dropdown__label-text">
							{memoizedActiveCountry ? Object.values(memoizedActiveCountry)[0] : customData.i18n.agenda_country_name }</p>
							<DropdownIcon />
					</div>
				</button>

				{/* dropdown content */}
				<div className='filter-dropdown__content-bg' ></div>
				<div
					className="filter-dropdown__content listbox listbox--multi listbox--multi-options filter-dropdown__container"
					role="listbox"
					aria-labelledby="type_label"
					aria-multiselectable="false"
					aria-activedescendant=""
				>
					<div className="filter-dropdown__header filter-dropdown__button-wrapper">
						<label id="type_label" className="listbox__label filter-dropdown__button-label-">{customData.i18n.agenda_country_label}</label>
						<button
							// onClick={() => handleCountryClick(null)}
						><CloseIcon /></button>
					</div>
					<ul className='filter-dropdown__list'>
						{/* get available country options */}
						{
							availableCountries.map((country, index) => {
								return (
									<li
										key={index}
										role="option"
										tabIndex={'0'}
										onClick={() => handleCountryClick(country)}
										onKeyDown={(event) => {
											if (event.key === 'Enter') {
												 handleCountryClick(country);
											}
									  }}
										className={`li-label filter-dropdown__list-item ${ country === memoizedActiveCountry ? 'tag--active' : '' }`}
										aria-selected={country === memoizedActiveCountry ? 'true' : 'false'}
									>
										<span className="listbox__option filter-dropdown__list-item-text">
											<CheckboxIcon />
											<label className="listbox__text">{Object.values(country)[0]}</label>
										</span>
									</li>
								);
							})
						}
						<li className='li-label filter-dropdown__list-item' >
						<button onClick={clearFilters}>Clear Filters</button>
						 </li>

					</ul>
				</div>

			</div>

		</div>
	);
};

export default memo(Filterbar);
